import type { FC } from 'react'
import { card, Em, SectionHead } from './primitives'
import { AskVisual, EditVisual, PlanVisual } from './SessionVisuals'

const STEPS: readonly { n: string; title: string; body: string; Visual: FC }[] = [
  {
    n: '01',
    title: 'You ask.',
    body: 'Say it in the chat. Pick image, video, sound or 3D, and set aspect, style, count and seed in the composer when you want them.',
    Visual: AskVisual,
  },
  {
    n: '02',
    title: 'It plans and runs.',
    body: 'Genie’s agent reads the canvas, picks a model that fits your Mac, and shows every tool it runs in the thread.',
    Visual: PlanVisual,
  },
  {
    n: '03',
    title: 'You keep editing.',
    body: 'Every result is a versioned frame. Use it as a reference, open it in an app, or turn it into video, 3D or a cutout.',
    Visual: EditVisual,
  },
]

export function HowItWorks() {
  return (
    <section id="how" className="landing-shell scroll-mt-20 pt-28">
      <SectionHead
        eyebrow="Session"
        title={
          <>
            A real session, <Em>in order</Em>
          </>
        }
        note="Three moves from a sentence to a frame you keep editing."
      />
      <ol className="grid gap-3 md:grid-cols-3">
        {STEPS.map(({ n, title, body, Visual }) => (
          <li key={n} className={`${card} flex flex-col p-6`}>
            <span className="num text-[12px] text-ink-3">{n}</span>
            <h3 className="mt-6 text-[22px] leading-[1.15] tracking-[-0.02em]">{title}</h3>
            <p className="mt-2 text-[14px] leading-relaxed text-ink-2">{body}</p>
            <div className="mt-auto box-content h-[252px] pt-6">
              <Visual />
            </div>
          </li>
        ))}
      </ol>
    </section>
  )
}
